import styled from "styled-components";

// background-color: ${props => props.theme.colors.background_primary};
export default styled.div`
  & {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background-color: ${(props) => props.theme.colors.piano};
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  form {
    display: flex;
    align-items: center;
    flex-direction: column;
    //height:25.0rem;
    width: 30em;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(p) => p.theme.colors.black};
    border-radius: 5px;
    gap: ${(props) => props.theme.spacing.spacing_06};
  }

  form img {
    width: 50%;
    height: auto;
    padding-top: ${(props) => props.theme.spacing.spacing_04};
  }

  form > div {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${(props) => props.theme.spacing.spacing_07};
    padding: ${(props) => props.theme.spacing.spacing_06};
  }

  .container-buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .button {
    padding: 0.5em;
    font-size: ${(props) => props.theme.spacing.spacing_05};
    width: 6.5em;
    height: 2em;
    background-color: ${(props) => props.theme.colors.green};
    color: ${(p) => p.theme.colors.white};
  }
  .login {
    background-color: ${(props) => props.theme.colors.green};
  }

  .register {
    font-size: ${(props) => props.theme.spacing.spacing_04};
    text-transform: uppercase;
    text-decoration: none;
  }

  @media (max-width: 600px) {
    .form {
      width: 20em;
    }
  }

  @media (max-width: 350px) {
    .form {
      width: 15em;
      height: 350px;
    }

    .button {
      font-size: ${(props) => props.theme.spacing.spacing_04};
      width: ${(props) => props.theme.spacing.spacing_09};
      height: ${(props) => props.theme.spacing.spacing_07};
    }
  }
`;
